import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';
import { comparatorFromRanking } from '../ordering';

export const SortedDaysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;

export const byDaysOfWeek = comparatorFromRanking(SortedDaysOfWeek);

export function nextDayOf(day: DayOfWeek): DayOfWeek {
  const currentIndex = SortedDaysOfWeek.indexOf(day);
  const nextIndex = (currentIndex + 1) % 7;
  return SortedDaysOfWeek[nextIndex];
}

export const dayOfWeekSchema = z.enum(SortedDaysOfWeek);
export const DayOfWeek = dayOfWeekSchema.enum;
export type DayOfWeek = z.infer<typeof dayOfWeekSchema>;

export const meetingBlockLikeSchema = z.object({
  day: dayOfWeekSchema,
  startPlainTime: z.instanceof(Temporal.PlainTime),
  endPlainTime: z.instanceof(Temporal.PlainTime),
});
export type MeetingBlockLike = z.infer<typeof meetingBlockLikeSchema>;

export const meetingBlockSchema = z
  .object({
    id: z.string(),
    classTimeId: z.string(),
  })
  .extend(meetingBlockLikeSchema.shape);
export type MeetingBlock = z.infer<typeof meetingBlockSchema>;

// Onboaring session only cares about meeting block's start and end time
// Use a dummy day of week for all such meeting blocks
export const OnboardingSessionPlaceholderDay: DayOfWeek = 'monday';

export const DayOfWeekLabelMap: Record<DayOfWeek, { abbr: string; full: string; day: number }> = {
  [DayOfWeek.monday]: { abbr: 'Mon', full: 'Monday', day: 1 },
  [DayOfWeek.tuesday]: { abbr: 'Tue', full: 'Tuesday', day: 2 },
  [DayOfWeek.wednesday]: { abbr: 'Wed', full: 'Wednesday', day: 3 },
  [DayOfWeek.thursday]: { abbr: 'Thu', full: 'Thursday', day: 4 },
  [DayOfWeek.friday]: { abbr: 'Fri', full: 'Friday', day: 5 },
  [DayOfWeek.saturday]: { abbr: 'Sat', full: 'Saturday', day: 6 },
  [DayOfWeek.sunday]: { abbr: 'Sun', full: 'Sunday', day: 7 },
};

export const abbrDayOfWeek = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
export const dayOfWeekAbbrSchema = z.enum(abbrDayOfWeek);
export const DayOfWeekAbbr = dayOfWeekAbbrSchema.enum;
export type DayOfWeekAbbr = z.infer<typeof dayOfWeekAbbrSchema>;

export const AbbrDayOfWeekToFull = {
  [DayOfWeekAbbr.mon]: DayOfWeek.monday,
  [DayOfWeekAbbr.tue]: DayOfWeek.tuesday,
  [DayOfWeekAbbr.wed]: DayOfWeek.wednesday,
  [DayOfWeekAbbr.thu]: DayOfWeek.thursday,
  [DayOfWeekAbbr.fri]: DayOfWeek.friday,
  [DayOfWeekAbbr.sat]: DayOfWeek.saturday,
  [DayOfWeekAbbr.sun]: DayOfWeek.sunday,
};
